import styled from 'styled-components';
import { Form as FormBase } from '@unform/web';
import { transparentize } from 'polished';
import { device } from 'styles/device';
import { ButtonBase } from 'components/Button/styles';

interface FormGroupsProps {
  columns: string;
}
interface ColumnContentProps {
  columns: string;
  margin?: string;
}
export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 0 15px 0 15px;
  justify-content: space-between;
  section {
    white-space: nowrap;
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 0.5px solid ${props => props.theme.fontColor};
    &:first-of-type {
      margin: 0px 0 15px 0;
    }
  }
`;

export const FormGroups = styled.div<FormGroupsProps>`
  grid-template-columns: ${props => props.columns};
  display: grid;
  > div {
    &:not(:first-of-type) {
      margin-left: 5px;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  margin: 0;

  > div {
    > button {
      align-self: flex-end;
      margin-top: 10px;
      padding: 0 15px 0 15px;
      width: 150px;
    }
  }
  .ButtonGroup {
    display: flex;
    justify-content: space-between;
    margin: 0 1rem;
  }
  header {
    align-items: baseline;
    > button {
      margin-right: 10px;
    }
  }
`;
export const Content = styled.div`
  padding: 0 15px 0 15px;
  flex: 1 1;
  height: -webkit-fill-available;
  section {
    padding-bottom: 10px;
  }
  .datas {
    max-width: 28rem;
  }
  .switchs {
    display: flex;
    justify-content: space-between;
    > div {
      margin-bottom: 2rem;
    }
  }
  .botao {
    margin: 0 auto;
  }
`;

export const ColumnContent = styled.div<ColumnContentProps>`
  display: grid;

  grid-template-columns: 1fr 1fr;
  grid-template-columns: ${props => props.columns};
  grid-column-start: 1;
  grid-column-end: 2;
  margin-bottom: 10px;
  height: 100%;
  @media ${device.laptopM} {
    grid-template-columns: 1fr;
  }

  > div {
    margin-right: 10px;
    margin: ${props => props.margin};
  }
  section {
    display: flex;
    justify-content: space-between;

    padding: 0 0 5px 0 !important;
    margin-bottom: 15px;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};

    &:first-of-type {
      margin: 0px 0 15px 0;
    }

    ${ButtonBase} {
      margin-top: -10px;
    }
  }
`;
